import { render, staticRenderFns } from "./YourPlanAddCourses.vue?vue&type=template&id=4225ff69&scoped=true&lang=pug&"
import script from "./YourPlanAddCourses.vue?vue&type=script&lang=js&"
export * from "./YourPlanAddCourses.vue?vue&type=script&lang=js&"
import style0 from "./YourPlanAddCourses.vue?vue&type=style&index=0&id=4225ff69&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225ff69",
  null
  
)

export default component.exports